var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGlassStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 311.8 340.2",
    style: {
      enableBackground: "new 0 0 311.8 340.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#EB8695;}\r\n\t.st2{fill:#648F3E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reverse_Green"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Reverse_Pink"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Reverse_White"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Reverse_1_"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Standard_Green"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Standard_Pink"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Standard_White"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Standard_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Black"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_99_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_853_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1573_",
    d: "M155.9,239.7c-54.7,0-99.2-44.5-99.2-99.2c0-54.7,44.5-99.2,99.2-99.2s99.2,44.5,99.2,99.2 C255.1,195.2,210.6,239.7,155.9,239.7z M155.9,50.2c-49.8,0-90.3,40.5-90.3,90.3s40.5,90.3,90.3,90.3s90.3-40.5,90.3-90.3 S205.7,50.2,155.9,50.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_852_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1579_",
    x: 135.8,
    y: 101.3,
    transform: "matrix(0.4462 0.8949 -0.8949 0.4462 204.1668 -47.248)",
    width: 9,
    height: 80
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_851_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1578_",
    x: 156.9,
    y: 146.3,
    transform: "matrix(0.427 0.9043 -0.9043 0.427 242.9216 -81.8126)",
    width: 58.3,
    height: 9
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_850_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1577_",
    x: 170.9,
    y: 132.2,
    transform: "matrix(0.9232 0.3842 -0.3842 0.9232 68.2754 -68.3618)",
    width: 68.6,
    height: 9
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_849_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1576_",
    x: 170.7,
    y: 45.7,
    width: 9,
    height: 76.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1069_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1070_",
    d: "M64,286.1c0-8.4,6.2-13.8,14-13.8c5.2,0,8.6,2.5,10.7,5.5l-3.8,2.2c-1.4-2-4-3.6-6.9-3.6 c-5.3,0-9.2,4-9.2,9.6c0,5.6,3.9,9.6,9.2,9.6c2.7,0,5.1-1.2,6.3-2.4v-4.1h-8v-4.1h12.6v10c-2.6,2.9-6.4,4.9-11,4.9 C70.2,300,64,294.5,64,286.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1072_",
    d: "M109.5,299.4v-26.7h4.7v22.6h11.8v4.1H109.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1074_",
    d: "M164.8,299.4l-2-5.2h-12.2l-2,5.2h-5.3l10.5-26.7h5.8l10.5,26.7H164.8z M156.7,277.4l-4.8,12.7h9.6 L156.7,277.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1077_",
    d: "M186.9,295.7l2.6-3.6c1.8,2,4.7,3.7,8.4,3.7c3.8,0,5.3-1.9,5.3-3.7c0-5.6-15.5-2.1-15.5-11.9 c0-4.4,3.8-7.8,9.7-7.8c4.1,0,7.5,1.4,10,3.8l-2.6,3.5c-2.1-2.1-5-3.1-7.8-3.1c-2.7,0-4.5,1.4-4.5,3.3c0,5,15.5,1.9,15.5,11.8 c0,4.4-3.2,8.3-10.3,8.3C192.8,299.9,189.3,298.2,186.9,295.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1079_",
    d: "M226.6,295.7l2.6-3.6c1.8,2,4.7,3.7,8.4,3.7c3.8,0,5.3-1.9,5.3-3.7c0-5.6-15.5-2.1-15.5-11.9 c0-4.4,3.8-7.8,9.7-7.8c4.1,0,7.5,1.4,10,3.8l-2.6,3.5c-2.1-2.1-5-3.1-7.8-3.1c-2.7,0-4.5,1.4-4.5,3.3c0,5,15.5,1.9,15.5,11.8 c0,4.4-3.2,8.3-10.3,8.3C232.6,299.9,229,298.2,226.6,295.7z"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassStandard);
export default __webpack_public_path__ + "static/media/Glass_Standard.538504de9c35c48eafce39d6052b6b35.svg";
export { ForwardRef as ReactComponent };